// extracted by mini-css-extract-plugin
module.exports = {"content":"Router_content__10qrd","contentInner":"Router_contentInner__79RmZ"};